// @ts-nocheck
class ProductInformationSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const dataContainer = document.querySelector('[product-collapsibles]');
    const container = this.querySelector('[secondary-product-collapsibles]');

    if (dataContainer && container) {
      const skipSelectors = [
        'style',
        'script',
        'custom-drawer',
        '[product-information-trigger]'
      ];

      Array.from(dataContainer.children).forEach((child) => {
        // Check if element matches any skip condition
        const shouldSkip = skipSelectors.some(selector =>
          child.matches(selector)
        );

        if (!shouldSkip) {
          const clone = child.cloneNode(true);
          container.appendChild(clone);
        }
      });
    }
  }
}

if (!customElements.get('product-information-section')) {
  customElements.define('product-information-section', ProductInformationSection);
}